<template>
  <v-card>
    <v-form @submit.prevent="submitAddSite()" ref="addSiteForm">
      <v-card-title>
        <span class="headline">Add Site {{isRequest || site.request ? 'Request' : ''}}</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field label="* Name" v-model="site.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Email"
              v-model="site.contactEmail"
              :rules="contactEmailRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Contact Phone"
              v-model="site.contactPhone"
              :rules="contactPhoneRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Location" :rules="locationRules" v-model="site.location"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="* Project"
              :items="projects"
              v-model="project"
              item-text="name"
              :rules="projectRules"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="!isRequest">
            <v-switch label="Request" v-model="site.request"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="addingSite"
        >{{ isRequest || site.request ? 'Create Request' : 'Add'}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SiteService from '@/services/requests/siteService'
import ProjectService from '@/services/requests/projectService'
import SiteValidation from '@/services/validation/siteValidation'
export default {
  mixins: [SiteValidation],
  props: {
    isRequest: Boolean,
  },
  data() {
    return {
      site: {
        name: '',
        location: '',
        contactEmail: '',
        contactPhone: '',
        projectId: '',
        request: false,
      },
      projects: [],
      addingSite: false,
      loadingProjects: false,
    }
  },
  methods: {
    submitAddSite() {
      if (!this.$refs.addSiteForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.addSite()
    },
    addSite() {
      this.loading = true
      if (this.isRequest) this.site.request = this.isRequest
      this.site.projectId = this.project
      SiteService.addSite(this.site)
        .then((result) => {
          this.loading = false
          this.$store.commit('sites/addToArrayState', {
            prop: 'sites',
            value: result.data.result,
          })
          this.resetForm()
          this.snack({ text: 'Site was added!', color: 'green' })
          this.close()
        })
        .catch((err) => {
          this.snackError()
          this.addingSite = false
          console.log(err)
        })
    },
    getProjects() {
      ProjectService.getProjects()
        .then((result) => {
          //console.log(result);
          this.projects = result.data.result
        })
        .catch((err) => {
          this.snackError()
        })
    },
    resetForm() {
      this.site.name = ''
      this.site.projectId = ''
      this.site.location = ''
      this.site.contactEmail = ''
      this.site.contactPhone = ''
      this.$refs.addSiteForm.resetValidation()
    },
    close() {
      this.$emit('close')
    },
  },
  mounted() {
    this.getProjects()
  },
  computed: {
    project: Store.getSet({ store: 'sites', prop: 'project' }),
  },
}
</script>

<style>
</style>
